export default __webpack_public_path__ + "static/media/icon-heart.0598df5e.svg";